import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { EnFormItem } from '../shared/LocalizedFields'

const NotificationForm = ({
  form,
  headingKZ,
  headingRU,
  headingEN,
  messageKZ,
  messageRU,
  messageEN
}) => {
  const FormItem = Form.Item
  return (
    <Form form={form} layout="vertical" hideRequiredMark>
      <FormItem
        key="headingKZ"
        label="headingKZ"
        name="headingKZ"
        rules={[{ required: true, message: 'Заголовок каз' }]}
        initialValue={headingKZ}
      >
        <Input placeholder="Заголовок (каз)" />
      </FormItem>
      <FormItem
        key="headingRU"
        label="headingRU"
        name="headingRU"
        rules={[{ required: true, message: 'Заголовок рус' }]}
        initialValue={headingRU}
      >
        <Input placeholder="Заголовок (рус)" />
      </FormItem>
      <EnFormItem
        name="headingEN"
        label="headingEN"
        initialValue={headingEN}
        placeholder="Заголовок (англ)"
      />
      <FormItem
        key="messageKZ"
        label="messageKZ"
        name="messageKZ"
        rules={[{ required: true, message: 'Описание каз' }]}
        initialValue={messageKZ}
      >
        <TextArea placeholder="Описание (каз)" />
      </FormItem>
      <FormItem
        key="messageRU"
        label="messageRU"
        name="messageRU"
        rules={[{ required: true, message: 'Описание рус' }]}
        initialValue={messageRU}
      >
        <TextArea placeholder="Описание (рус)" />
      </FormItem>
      <EnFormItem
        name="messageEN"
        label="messageEN"
        initialValue={messageEN}
        placeholder="Описание (англ)"
        multiline
      />
    </Form>
  )
}

NotificationForm.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  headingKZ: PropTypes.string,
  headingRU: PropTypes.string,
  messageKZ: PropTypes.string,
  messageRU: PropTypes.string,
  headingEN: PropTypes.string,
  messageEN: PropTypes.string
}

export default NotificationForm
